import { useState } from 'react';
import {
  Container,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
} from '@mui/material';
import useAppStore from '../store/useAppStore';
import { Link, Navigate, useNavigate } from 'react-router';
import api from '../services/api';
import { produce } from 'immer';

export default function Login() {
  const navigate = useNavigate();
  const login = useAppStore((state) => state.login);
  const isLoggedIn = useAppStore((state) => state.user.isLoggedIn);
  const [formData, setFormData] = useState({
    user_id: '',
    user_password: '',
  });
  const [userLogin, { isLoading, isError, error }] =
    api.endpoints.userLogin.useMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    userLogin({
      user_id: formData.user_id,
      user_password: formData.user_password,
    })
      .unwrap()
      .then((data) => {
        login(
          formData.user_id || '',
          data.user_name || '',
          data.comp_name || '',
          data.industry || '',
        );
        navigate('/');
      });
  };

  const handleChange = (e) => {
    setFormData(
      produce((draft) => {
        draft[e.target.name] = e.target.value;
      }),
    );
  };

  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            登入
          </Typography>

          {isError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error.message || '未知錯誤'}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="用戶ID"
              name="user_id"
              autoComplete="username"
              autoFocus
              disabled={isLoading}
              value={formData.user_id}
              onChange={handleChange}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="user_password"
              label="密碼"
              type="password"
              autoComplete="current-password"
              disabled={isLoading}
              value={formData.user_password}
              onChange={handleChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              loading={isLoading}
            >
              登入
            </Button>
            <Box sx={{ textAlign: 'center' }}>
              <Link to="/register" style={{ textDecoration: 'none' }}>
                <Typography variant="body2" color="primary">
                  還沒有帳號？立即註冊
                </Typography>
              </Link>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
